'use strict';

module.exports = {
    Boolean: 'valueBoolean',
    String: 'valueString'
};
